import type {
    SalesOrderItem,
    SalesOrderStatus,
} from '@/lib/api/sales-order-api'
import { m } from '@/lib/paraglide/messages'

/** Số dòng KiotViet đang gắn SP tạm "Chưa nối KiotViet" (M-145). */
export function countKiotVietUnlinked(
    items: SalesOrderItem[] | undefined,
): number {
    return (items ?? []).filter((it) => it.kiotviet_unlinked).length
}

/** Đơn còn nối/nối lại được: chưa xuất kho (tồn chưa bị trừ). Khớp
 *  kiotVietLinkable ở BE (sales_order/kiotviet_link.go). */
export function isKiotVietLinkable(status: SalesOrderStatus): boolean {
    return (
        status === 'draft' ||
        status === 'new' ||
        status === 'awaiting_packaging' ||
        status === 'confirmed'
    )
}

/** Nhãn SP KiotViet đang nối: tên SP KiotViet; mã không còn trên KiotViet thì
 *  "<mã> (không còn trên KiotViet)"; chưa biết tên thì mã. */
export function kiotVietLinkedLabel(
    code: string,
    info?: { name?: string; missing?: boolean },
): string {
    if (info?.name) return info.name
    if (info?.missing) return m.kiotviet_code_missing({ code })
    return code
}
